<template>
  <main class="no-english flex-all-center">
    <p class="note">English page is not available.</p>
  </main>
</template>

<script>
export default {
  name: "NotEnglish",
};
</script>

<style scoped>
.no-english {
  min-height: calc(100vh - 175px);
  .note {
    line-height: 1.5;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/NotEnglish.vue